import React, { FC, useState } from "react";
import { Table } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { usePurchasePoDetailsModel } from "../scmPurchasePoModel";
import { RouterParamType } from "@/model/navModel";
import { ISCMPoGoodsDetail } from "../scmPurchasePoType";
import { formatNum } from "@/utils/utils";
import useGlobalModel from "@/model/globalModel";
import { useScmSaleRoDetailModel } from "../../scmSaleRo/scmSaleRoModel"


export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const { user: { shopId }, } = useGlobalModel();
    const { getTreeNodeName } = useScmSaleRoDetailModel();
    const { lookGoodsList, setLookGoodsList } = usePurchasePoDetailsModel()
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const columns: ColumnsType<ISCMPoGoodsDetail> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            align: "center",
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '商品编号',
            width: 140,
            dataIndex: 'materialCode',
            fixed: "left",
        }, {
            title: '商品名称',
            width: 160,
            dataIndex: 'materialName',
            fixed: "left",
            render: (text: string) => <p className="ellipsis" title={text}>{text}</p>
        }, {
            title: '开单数量',
            width: 100,
            dataIndex: 'num',
        }, {
            title: '赠品数量',
            width: 100,
            dataIndex: 'giftsNum',
            // editable: true,
        }, {
            title: '采购单价',
            width: 136,
            dataIndex: 'price',
            render: (text: any) => `￥${formatNum(text)}`
            // }, {
            //     title: '下浮',
            //     width: 100,
            //     dataIndex: 'discountRate',
            //     editable: discountIsEdit(newFormVal.preferentialTypeCode as DictCodeEnmu, 'discountRate') && newFormVal.discountRate == 0 ? true : false,
        }, {
            title: '总计',
            width: 136,
            dataIndex: 'amount',
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '商品类型',
            width: 120,
            dataIndex: 'typeName',
        }, {
            title: '替换编号',
            width: 140,
            dataIndex: 'replaceCode',
        }, {
            title: '损坏数量',
            width: 100,
            dataIndex: 'damageNum',
        }, {
            title: '已入库数量',
            width: 100,
            dataIndex: 'stockIoNum',
        }, {
            title: '驳回数量',
            width: 100,
            dataIndex: 'rejectNum',
            render: (text: string) => <span className={+text > 0 ? "color-red" : ""}>{text}</span>
        }, {
            title: '本次入库',
            width: 100,
            dataIndex: 'confirmNum',
        }, {
            title: '入库总计',
            width: 136,
            dataIndex: 'stockIoAmount',
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '入库员',
            width: 100,
            dataIndex: 'stockIoStaff',
            render: (text: string) => getTreeNodeName(text)
        }, {
            title: '入库状态',
            width: 130,
            dataIndex: 'stockIoStatus',
            render: (text: string) => getTreeNodeName(text)
        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        },
        {
            title: '仓库',
            width: 150,
            dataIndex: "warehouseCode",
        },
        {
            title: '货位',
            width: 150,
            align: "center",
            dataIndex: 'shelfCode',
        },
        {
            title: '采购订单号',
            width: 170,
            dataIndex: 'planCode',
        }, {
            title: '积压标记',
            width: 80,
            dataIndex: 'overstock',
        }, {
            title: '积压等级',
            width: 80,
            dataIndex: 'overstockGrade',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
        }
    ];



    return (
        <YhBox title="" style={{ marginBottom: "75px" }}>
            <Table
                rowKey={record => record.key}
                rowClassName='editable-row yh-edit-table-tr'
                rowSelection={{
                    selectedRowKeys: selectedRowKeys, //记录选中
                    onChange: (selectedRowKeys: React.Key[], selectedRows: ISCMPoGoodsDetail[]) => {
                        setSelectedRowKeys(selectedRowKeys as string[]);
                    }
                }}
                columns={columns}
                dataSource={lookGoodsList}
                pagination={{
                    position: ["bottomCenter"],
                    defaultPageSize: 100,
                    hideOnSinglePage: true,
                    showTotal: (total) => `共${total}条`,
                }}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}